/*
* Scroller checked
*/

$.fn.Scroller = function()
{
  let self = this;

  self.el = {
    homeScreen: self.find('.page--home'),
    creditsScreen: self.find('.page--credits'),
    sections: self.find('.section, .screen'),
  };

  self.settings = {
    firstScreenOffset: 40,
  };

  self.watchers = {
    currentScroll: 0,
    currentSection: undefined,
    hasScrolledPastFirstScreen: false,
    hasArrivedAtLastScreen: false,
  };

  self.scrolled = function()
  {
    // current scroll
    self.watchers.currentScroll = self.scrollTop();

    // check if has scrolled past first screen
    if (!self.watchers.hasScrolledPastFirstScreen && self.watchers.currentScroll >= self.el.homeScreen.outerHeight(false) - self.settings.firstScreenOffset){
      self.watchers.hasScrolledPastFirstScreen = true;
      self.trigger('screen', self.watchers);
    } else if (self.watchers.hasScrolledPastFirstScreen && self.watchers.currentScroll < self.el.homeScreen.outerHeight(false) - self.settings.firstScreenOffset){
      self.watchers.hasScrolledPastFirstScreen = false;
      self.trigger("screen", self.watchers);
    }

    // check if has arrived at the last screen
    if (!self.watchers.hasArrivedAtLastScreen && self.watchers.currentScroll >= self.get(0).scrollHeight - (self.el.creditsScreen.outerHeight(false) * 2) - self.settings.firstScreenOffset){
      self.watchers.hasArrivedAtLastScreen = true;
      self.trigger('screen', self.watchers);
    } else if (self.watchers.hasArrivedAtLastScreen && self.watchers.currentScroll < self.get(0).scrollHeight - (self.el.creditsScreen.outerHeight(false) * 2) - self.settings.firstScreenOffset){
      self.watchers.hasArrivedAtLastScreen = false;
      self.trigger("screen", self.watchers);
    }

    // check current section
    var currentSection = undefined;
    self.el.sections.each(function(){
      let section = $(this);
      if (currentSection == undefined){
        currentSection = section;
      } else if (section.offset().top > currentSection.offset().top && section.offset().top < $(window).height() / 2){
        currentSection = section;
      }
    });
    if (self.watchers.currentSection != currentSection.get(0)){
      self.watchers.currentSection = currentSection.get(0);
      self.trigger("currentSection");
    }

    // trigger alternative scroll event
    self.trigger("scrolled");
  };

  return function() {
    $(window).on("resize orientationchange load", self.scrolled);
    self.on("scroll", self.scrolled);
    self.scrolled();
    return self;
  }();
};

export default class Scroller {

  constructor(selector) {
    this.selector = selector;
  }

  init() {
    this.scroller = $(this.selector).Scroller();
  }

  getCurrentSection() {
    return this.scroller.watchers.currentSection;
  }

  scrollTo(selector) {
    if (selector != "#"){
      var obj = this;
      this.scroller.scrollTop(0);
      this.scroller.scrollTop(this.scroller.find(selector).offset().top);
      setTimeout(function(){
        obj.scroller.closest('.over').removeClass('has-scrolled go-down go-up');
        if (obj.scroller.scrollTop() > 10) {
          obj.scroller.closest('.over').addClass('go-up');
        }
        if (!obj.scroller.find(selector).is(':last-child')){
          obj.scroller.closest('.over').addClass('go-down');
        }
      }, 250);
    }
  }

}
